import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Menu from './Pages/Menu';
import GameDetailPage from './Pages/Game';

const ScrollToLowercase = () => {
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;
    const lowercasePath = currentPath.toLowerCase();

    if (currentPath !== lowercasePath) {
      window.location.replace(lowercasePath);
    }
  }, [location]);

  return null;
};

const App = () => {
  return (
    <Router>
      <ScrollToLowercase />
      <Routes>
        <Route path="/" element={<Menu />} />
        <Route path="/:gameUrl" element={<GameDetailPage />} />
      </Routes>
    </Router>
  );
};

export default App;